import {Message, Field, OneOf, Type} from 'protobufjs';
import {WallPieceRotation} from '../map/WallPiece';

export type PlayerAction =
    | 'leave'
    | 'select'
    | 'place'
    | 'start'
    | 'cancel'
    | 'playWithBots'
    | 'fire'
    | 'build'
    | 'movePointer';

@Type.d('LeaveAction')
class LeaveAction extends Message<LeaveAction> {}

@Type.d('SelectAction')
class SelectAction extends Message<SelectAction> {
    @Field.d(1, 'int32')
    public spawnIndex: number;
}

@Type.d('PlaceAction')
class PlaceAction extends Message<PlaceAction> {
    @Field.d(1, 'int32')
    public x: number;

    @Field.d(2, 'int32')
    public y: number;
}

@Type.d('StartAction')
class StartAction extends Message<StartAction> {
    @Field.d(1, 'string')
    public name: string;

    @Field.d(2, 'string')
    public idToken: string;

    @Field.d(3, 'string')
    public mapName: string;
}

@Type.d('CancelAction')
class CancelAction extends Message<CancelAction> {}

@Type.d('PlayWithBotsAction')
class PlayWithBotsAction extends Message<PlayWithBotsAction> {}

@Type.d('FireAction')
class FireAction extends Message<FireAction> {
    @Field.d(1, 'int32')
    public id: number;

    @Field.d(2, 'float')
    public x: number;

    @Field.d(3, 'float')
    public y: number;
}

@Type.d('BuildAction')
class BuildAction extends Message<BuildAction> {
    @Field.d(1, 'int32')
    public x: number;

    @Field.d(2, 'int32')
    public y: number;

    @Field.d(3, 'int32')
    public rotation: WallPieceRotation;
}

@Type.d('MovePointerAction')
class MovePointerAction extends Message<MovePointerAction> {
    @Field.d(1, 'float')
    public x: number;

    @Field.d(2, 'float')
    public y: number;

    @Field.d(3, 'float')
    public velX: number;

    @Field.d(4, 'float')
    public velY: number;
}

@Type.d('ClientMessage')
class ClientMessage extends Message<ClientMessage> {
    @Field.d(1, 'int32')
    public seq: number;

    @Field.d(2, LeaveAction)
    public leave: LeaveAction;

    @Field.d(3, SelectAction)
    public select: SelectAction;

    @Field.d(4, PlaceAction)
    public place: PlaceAction;

    @Field.d(5, StartAction)
    public start: StartAction;

    @Field.d(6, CancelAction)
    public cancel: CancelAction;

    @Field.d(7, PlayWithBotsAction)
    public playWithBots: PlayWithBotsAction;

    @Field.d(8, FireAction)
    public fire: FireAction;

    @Field.d(9, BuildAction)
    public build: BuildAction;

    @Field.d(10, MovePointerAction)
    public movePointer: MovePointerAction;

    @OneOf.d(
        'leave',
        'select',
        'place',
        'start',
        'cancel',
        'playWithBots',
        'fire',
        'build',
        'movePointer'
    )
    public actionKind: PlayerAction;
}

function messageClassForPlayerAction(action: PlayerAction): typeof Message {
    return {
        leave: LeaveAction,
        select: SelectAction,
        place: PlaceAction,
        start: StartAction,
        cancel: CancelAction,
        playWithBots: PlayWithBotsAction,
        fire: FireAction,
        build: BuildAction,
        movePointer: MovePointerAction,
    }[action];
}

function buildMessage(actionKind: PlayerAction, params: {}, seq: number): Message<ClientMessage> {
    const ActionClass: typeof Message = messageClassForPlayerAction(actionKind);
    const reason = ActionClass.verify(params);
    if (reason) {
        throw new Error(reason);
    }
    return ClientMessage.create({seq, [actionKind]: ActionClass.create(params)});
}

export function encodeMessage(actionKind: PlayerAction, params: {}, seq: number): Uint8Array {
    const message = buildMessage(actionKind, params, seq);
    return ClientMessage.encode(message).finish();
}



// WEBPACK FOOTER //
// ./src/common/connection/messages.ts